import React from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';
import { FAQ_ITEMS } from '../data/products';

export const FAQSection: React.FC = () => {
  return (
    <section id="faq" className="py-16 md:py-24 bg-[#FCFAF8] relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center space-y-3 mb-12">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#EDE9FE] text-[#6B21A8] text-xs font-bold uppercase tracking-wider border border-[#C084FC]/40">
            <HelpCircle className="w-3.5 h-3.5 text-[#8B5CF6]" />
            <span>Frequently Asked Questions</span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl font-extrabold text-[#292524]">
            Got Questions? We’ve Got Answers!
          </h2>
          <p className="text-xs sm:text-sm text-[#78716C]">
            Everything you need to know about sizing, durability, reusable wear, and custom commissions.
          </p>
        </div>

        {/* Accordion FAQ using native accessible details elements */}
        <div className="space-y-3.5">
          {FAQ_ITEMS.map((item, idx) => (
            <details
              key={idx}
              name="faq-accordion"
              className="group p-5 rounded-2xl bg-white border border-[#EADFCF] shadow-xs hover:border-[#D4AF37] transition-all open:bg-[#FFFDF9] open:border-[#D4AF37]/70"
            >
              <summary className="flex items-center justify-between cursor-pointer list-none text-sm sm:text-base font-bold text-[#292524] group-hover:text-[#B45309]">
                <span>{item.question}</span>
                <span className="p-1 rounded-full bg-[#FAF5EE] text-[#78716C] group-open:rotate-180 group-open:bg-[#FEF08A] group-open:text-[#854D0E] transition-transform duration-200 shrink-0 ml-3">
                  <ChevronDown className="w-4 h-4" />
                </span>
              </summary>
              <div className="pt-3 text-xs sm:text-sm text-[#57534E] leading-relaxed border-t border-[#F5EBE0] mt-3 animate-in fade-in duration-200">
                {item.answer}
              </div>
            </details>
          ))}
        </div>

      </div>
    </section>
  );
};
